@if (isNavigationPending()) {
  <p-progressbar class="absolute top-0 left-0 w-full"
                 styleClass="!rounded-none !bg-transparent !border-0 !h-[3px] z-app-overlay-50"
                 mode="indeterminate"></p-progressbar>

  <div class="fixed inset-0 -z-1">
    <gc-spinner></gc-spinner>
  </div>
}

<p-toast #appToast
         [key]="ToastKey.App"
         styleClass="!z-app-overlay-10">
  <ng-template #message let-message>
    <gc-toast-content [message]="message" [toast]="appToast"></gc-toast-content>
  </ng-template>
</p-toast>

<router-outlet></router-outlet>
